<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="工单拆分"
      :page="page"
      :show-query="true"
      :get-data-func="api.getDocOperationList"
      v-if="trendShow"
      :temp-params="tempParams"
      urlHash="production/ticketmanagement/split"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require('@/api/production/workDoc').default,
      tempParams: {
        WorkDocProperty: 2
      },
      trendShow: true,
   
    };
  },
  
};
</script>
